import { endPoint, endPointTask } from './base.config';

export const task = {
  get: endPointTask + '/v1/tasks',
  add: endPointTask + '/v1/tasks',
  update: endPointTask + '/v1/tasks/:id',
  sortIndex: endPointTask + '/v1/tasks/:id/sort-index',
  getById: endPointTask + '/v1/tasks/:id',
  getAttachments: endPointTask + '/v1/tasks/:id/attachments',
  addAttachments: endPointTask + '/v1/tasks/:id/attachments',
  sendAttachments: endPointTask + '/v1/tasks/:id/attachments/send',
  deleteAttachments: endPointTask + '/v1/tasks/:id/attachments/:fileId',
  getComments: endPointTask + '/v1/tasks/:id/comments',
  addComment: endPointTask + '/v1/tasks/:id/comments',
  updateComment: endPointTask + '/v1/tasks/:id/comments/:commentId',
  getCommentById: endPointTask + '/v1/tasks/:id/comments/:commentId',
  deleteComment: endPointTask + '/v1/tasks/:id/comments/:commentId',
  getLabelS2: endPointTask + '/v1/tasks/:id/lables2Tasks',
  updateLabelS2: endPointTask + '/v1/tasks/:id/lables2Tasks',
  assignUsers: endPoint + 'companyUsers/fetchByCompanyId',
  simpleUpload: endPointTask + '/v1/files/simple-upload',
  getHistories: endPointTask + '/v1/tasks/:id/histories',
  getNotifications: endPointTask + '/v1/tasks/by-user/notifications',
  markAll: endPointTask + '/v1/tasks/by-user/notifications/mark-all',
  readed: endPointTask + '/v1/tasks/by-user/notifications/:id/readed',
  countPending: endPointTask + '/v1/tasks/:companyId/count-pending',
  dashboard: endPointTask + '/v1/tasks/:companyId/task-pending-latest',
  static: endPointTask + '/v1/task-static',
  getOverview: endPointTask + '/v1/task-overview',
  getCreators: endPointTask + '/v1/task/get/creator',
  getCompanies: endPointTask + '/v1/task/get/companies',
  checkBilagskyEmailForward: endPointTask + '/v1/task/check-bilagsky-email-forward/:companyId',
};

export const taskLabel = {
  get: endPointTask + '/v1/labels',
  getLabelInCompany: endPointTask + '/v1/labels/get/company',
  add: endPointTask + '/v1/labels',
  update: endPointTask + '/v1/labels/:id',
  getById: endPointTask + '/v1/labels/:id',
  delete: endPointTask + '/v1/labels/:id',
};

export const taskTemplate = {
  get: endPointTask + '/v1/templates',
  add: endPointTask + '/v1/templates',
  update: endPointTask + '/v1/templates/:id',
  getById: endPointTask + '/v1/templates/:id',
  delete: endPointTask + '/v1/templates/:id',
};
